import * as yup from "yup";

export const contactSchema = yup.object().shape({
  name: yup.string().required("Esse campo é obrigatório"),
  phone: yup.string().required("Esse campo é obrigatório"),
  email: yup.string().email("Insira um e-mail válido").nullable(),
  function: yup.string()
});
